import { DateTime } from 'luxon';
import React from 'react';
import { BrowserView } from 'react-device-detect';
import { Link } from 'react-router-dom';

import { useToast } from 'Component/Alerta';
import Botao from 'Component/Botao';
import Icone from 'Component/Icone';
import RelogioDePonto from 'Interface/RelogiosDePonto';
import { useRemoverRelogioDePontoMutation } from 'View/Service/Default/RelogiosDePonto';

interface Props {
  dados: RelogioDePonto;
  btnRemover?: boolean;
  btnAssinar?: boolean;
}

const Lista = ({
  dados,
  btnRemover = true,
  btnAssinar = false,
}: Props): React.ReactElement => {
  const toast = useToast();
  const [removerRelogio] = useRemoverRelogioDePontoMutation();

  const remover = async (): Promise<void> => {
    try {
      await removerRelogio({ id: dados.id }).unwrap();

      toast({
        conteudo: 'Removido com sucesso!',
        tema: 'success',
      });
    } catch (erro) {
      toast({
        titulo: 'Erro ao remover',
        conteudo: 'Verifique o registro de log para mais detalhes!',
        tema: 'danger',
      });
    }
  };

  return (
    <div className="d-flex border-bottom align-items-center justify-content-between py-2 px-3">
      <div className="fs-4">
        <Link
          to={
            !btnAssinar
              ? `/usuarios/editar/${dados.vinculo_empregaticio?.usuario_id}/relogios-de-ponto/editar/${dados.id}`
              : `/relogios-de-ponto/assinar/${dados.id}`
          }
          className="text-decoration-none"
        >
          {dados.mes}/{dados.ano}
        </Link>
        <small className="text-muted fs-6 d-block">
          {dados.vinculo_empregaticio?.empresa?.nome_fantasia}
        </small>
      </div>
      <BrowserView className="d-flex align-items-center">
        <div className="ms-5 fs-5 text-end">
          <div>
            {dados.assinado ? (
              <>
                <img src={dados.assinatura} height={40} />
                <small className="d-block text-muted" style={{ fontSize: 10 }}>
                  {dados.data_da_assinatura
                    ?.data()
                    .toLocaleString(DateTime.DATETIME_SHORT)}
                </small>
              </>
            ) : (
              <Icone nome="x-lg" className="text-danger" />
            )}
          </div>
        </div>
        <div className="ms-5 fs-5 text-end">
          <div className="fs-4">
            {dados.assinado ? (
              <Icone nome="check-lg" className="text-success" />
            ) : (
              <Icone nome="x-lg" className="text-danger" />
            )}
            <small className="text-muted fs-6 d-block">Assinado</small>
          </div>
        </div>
        <div className="ms-5 fs-5 text-end">
          <div className="fs-4">
            {dados.criado.data().toLocaleString(DateTime.DATETIME_SHORT)}
            <small className="text-muted fs-6 d-block">Criado em</small>
          </div>
        </div>
        <div className="ms-2 fs-5 text-end">
          <Botao
            icone="cloud-download-fill"
            tema="success"
            className="ms-5"
            onClick={() => window.open(dados.url)}
          />{' '}
          {btnRemover && (
            <Botao
              icone="trash"
              tema="danger"
              confirmacao="Você tem certeza que deseja remover esse registro? Essa ação é irreversivel."
              onClick={remover}
            />
          )}
        </div>
      </BrowserView>
    </div>
  );
};

export default Lista;
